<template lang="pug">
  .gmenu
    b-container(fluid style="background: white")
      b-row.align-items-center
        b-col.ml-0.pl-0(cols="2")
          a.navbar-brand.m-1(href="/")
            img#logo(alt="Logo" src="../assets/logos/logo_icra_header.svg")
        b-col
          #nav.m-4.float-right
            router-link#menuLink(:class="isActive('Home')" to='/') Home
            router-link#menuLink(:class="isActive('Explore')" to='/explore') Find your NBS
            router-link#menuLink(:class="isActive('NBSList')" to='/nbslist') NBS List
            router-link#menuLink(:class="isActive('Case Study')" to='/casestudy') Add case-study
            router-link#menuLink(:class="isActive('Case Filter')" to='/casefilter') Case-studies
            router-link#menuLink(:class="isActive('About')" to='/about') About
          //router-link#menuLink(to='/about') About
      router-view
</template>

<script>
  export default {
    name: "generalMenu",
    computed: {
      currentRouteName() {
        return this.$route.name;
      }
    },
    methods:{
      isActive(thisLink){
        if(this.currentRouteName === thisLink) return "active";
      }
    }
  }
</script>

<style scoped>
  #logo{
    height: 145px;
    width: auto;
    margin-left: 80px;
    margin-top: 14px;
    margin-bottom: 14px;
  }
  #menuLink{
    color: #5E686D;
    margin-left: 30px;
    /* menu superior */

    font-family: Lato;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }
  .active{
    font-weight: 700;
    color: #00ACE5 !important;
    /*text-decoration-line: underline;*/
  }
</style>